import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import { ArcadeLogo } from "@arcadeai/design-system/components/ui/atoms/icons/arcade-logo";
import {
  ErrorTemplate,
  ErrorTemplateActions,
  ErrorTemplateContent,
  ErrorTemplateDescription,
  ErrorTemplateIcon,
  ErrorTemplateLogo,
  ErrorTemplateTitle,
} from "@arcadeai/design-system/components/ui/templates/error-template";
import { createFileRoute, Link } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { ArrowLeft, ShieldX } from "lucide-react";
import { z } from "zod";

const forbiddenSearchSchema = z.object({
  requiredPermission: fallback(z.string(), "").default(""),
});

export const Route = createFileRoute("/_authenticated/403")({
  validateSearch: zodValidator(forbiddenSearchSchema),
  component: ForbiddenPage,
});

function ForbiddenPage() {
  const { requiredPermission } = Route.useSearch();

  return (
    <ErrorTemplate>
      <ErrorTemplateContent>
        <ErrorTemplateLogo>
          <ArcadeLogo className="h-7 w-auto text-foreground" />
        </ErrorTemplateLogo>

        <ErrorTemplateIcon>
          <ShieldX className="h-10 w-10 text-muted-foreground/60" />
        </ErrorTemplateIcon>

        <ErrorTemplateTitle>Access denied</ErrorTemplateTitle>
        <ErrorTemplateDescription>
          {requiredPermission
            ? `You don't have the "${requiredPermission}" permission required for this page. Contact your organization admin to request access.`
            : "You don't have permission to view this page. Contact your organization admin to request access."}
        </ErrorTemplateDescription>

        <ErrorTemplateActions>
          <Button
            className="h-12 min-w-[160px] px-10 font-semibold text-base shadow-lg transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl"
            render={<Link to="/" />}
            size="lg"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Go Home
          </Button>
        </ErrorTemplateActions>
      </ErrorTemplateContent>
    </ErrorTemplate>
  );
}
